module.exports = __webpack_public_path__ + "img/pc-card-placeholder3.15cc0242.svg";